import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { isNumber } from 'utils';

import { Text, WithAspect, DynamicComponent } from '..';

import s from './Skeleton.module.scss';

const cx = cn.bind(s);

const Skeleton = ({
  className,
  length,
  variant,
  width = 0,
  aspect = null,
  height = 0,
  radius = 'smooth',
  ...attrs
}) => {
  let textContent = length ? '_'.repeat(length) : null;
  if (!height && !length) {
    textContent = '_';
  }
  const styles = {};

  if (width) {
    styles.width = `${width}${isNumber(width) ? 'px' : ''}`;
  }
  if (height) {
    styles.height = `${height}${isNumber(height) ? 'px' : ''}`;
  }
  const rootProps = {
    ...attrs,
    style: styles,
    tag: aspect ? WithAspect : 'div',
    aspect: aspect || null,
    className: cx(className),
  };

  return (
    <DynamicComponent {...rootProps}>
      <Text
        className={cx('skeleton', {
          [`radius-${radius}`]: radius,
          skeletonInline: length,
        })}
        as="div"
        variant={variant}
        {...attrs}
      >
        {textContent}
      </Text>
    </DynamicComponent>
  );
};

Skeleton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  radius: PropTypes.oneOf(['none', 'smooth', 'round', 'circle']),
  length: PropTypes.number,
  aspect: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  variant: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Skeleton;
